import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { color } from '../templates/Ui';
import _ from 'lodash';
export const StyledInputWrapper = styled.div `
    position: relative;
    margin-bottom: 10px;

    &:first-child&:last-child {
        margin: 0;
    }
`;
export const StyledInput = styled.input `
    position: absolute;
    top: 5px;
    left: 3px;
    margin: 0;
    padding: 0;
    height: auto;
    width: auto;

    &:checked + label {
        color: ${props => props.theme.primary.base};
        font-weight: 600;

        &::before {
            border-color: ${color.border.input};
            background-color: #fff;
        }
        &::after {
            opacity: 1;
        }
    }

    &:checked:disabled + label {
        color: #a0a0a0;

        &::before {
            background-color: #a0a0a0;
            border-color: #a0a0a0;
        }
    }

    &:indeterminate + label {
        color: ${props => props.theme.primary.base};
        font-weight: 600;

        &::before {
            border-color: ${color.border.input};
            background-color: #fff;
        }
        &::after {
            background-image: url("data:image/svg+xml, %3Csvg width='15' height='12' viewBox='0 0 15 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4.4C1 4.17909 1.17909 4 1.4 4H13.6C13.8209 4 14 4.17909 14 4.4V6.6C14 6.82091 13.8209 7 13.6 7H1.4C1.17909 7 1 6.82091 1 6.6V4.4Z' fill='currentColor'/%3E%3C/svg%3E");
            opacity: 1;
        }
    }
`;
const StyledLabel = styled.label `
    transition: color 150ms ease-in-out;
    display: inline-block;
    padding: 5px 0 5px 30px;
    vertical-align: middle;
    color: ${props => props.theme.primary.base};
    font-weight: 400;
    cursor: pointer;
    user-select: none;

    &::before {
        transition: border-color 150ms ease-in-out;
        position: absolute;
        content: '';
        width: 20px;
        height: 20px;
        left: 0;
        top: 5px;
        border-radius: 3px;
        background-color: #ffffff;
        border: 1px solid #dfe0e8;
    }

    &::after {
        transition: opacity 150ms ease-in-out;
        position: absolute;
        content: '';
        width: 15px;
        height: 11px;
        left: 3px;
        top: 10px;
        background-repeat: no-repeat;
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='15px' height='12px' viewBox='0 0 15 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3EPath%3C/title%3E%3Cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='GEBRUIKER-TOEVOEGEN' transform='translate(-958.000000, -273.000000)' fill='currentColor'%3E%3Cg id='Page' transform='translate(360.000000, 153.000000)'%3E%3Cg id='Group' transform='translate(29.000000, 26.000000)'%3E%3Cg id='Group-2' transform='translate(564.000000, -0.000000)'%3E%3Cpath d='M10.03658,102.352328 L18.2629939,94.1259145 C18.4308799,93.9580285 18.7106899,93.9580285 18.8785759,94.1259145 L19.8858919,95.1332305 C20.0537779,95.3011165 20.0537779,95.5809265 19.8858919,95.7488125 L10.335044,105.29966 C10.167158,105.467546 9.90600196,105.467546 9.73811596,105.29966 L5.111924,100.673468 C4.962692,100.524236 4.962692,100.244426 5.111924,100.07654 L6.13789399,99.0692245 C6.30577999,98.9013385 6.58558999,98.9013385 6.73482199,99.0692245 L10.03658,102.352328 Z' id='Path'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        opacity: 0;
    }
`;
const Checkbox = ({ label, className, id, indeterminate, ...props }) => {
    const [fid] = useState(id || _.uniqueId('field-'));
    return (_jsx(_Fragment, { children: _jsxs(StyledInputWrapper, { className: className, children: [_jsx(StyledInput, { type: "checkbox", id: fid, "data-testid": `${props['data-testid'] ?? 'checkbox'}__input`, ...props, ref: input => {
                        if (!input) {
                            return;
                        }
                        input.indeterminate = indeterminate || false;
                        if (indeterminate) {
                            input.checked = false;
                        }
                    } }), _jsx(StyledLabel, { htmlFor: fid, children: label })] }) }));
};
export default Checkbox;
